import { z } from 'zod';

import { clientSchema } from 'entities/Client';
import { idWithNameSchema } from 'entities/IdWithName';

import { managerMeetingSchema, responsibleMeetingSchema } from './MeetingEntities';
import { meetingSlotSchema } from './MeetingSlot';
import { meetingStatus } from './MeetingStatus';

export const meetingSchemaBase = z.object({
  id: z.number(),
  status: meetingStatus,
  slot: meetingSlotSchema,
  project: idWithNameSchema,
  client: clientSchema,
  is_offline: z.boolean(),
  manager: managerMeetingSchema,
  responsible: responsibleMeetingSchema,
});
